import React from "react";
import {
  Dashboard
} from "../../_metronic/_partials";

export function DashboardPage({symbol,conversionrate,language,isprofilecomplete, userinfo}) {
  return <Dashboard symbol={symbol} conversionrate={conversionrate} language={language} isprofilecomplete={isprofilecomplete} userinfo={userinfo}/>;
}
